module.exports = __webpack_public_path__ + "img/20191023165007105.14a77f59.jpg";